






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import AlertArea from "../../components/AlertArea.vue";
import http from "../../plugins/http";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
      * data
      ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
      * mounted
      ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/login/student_from_sso`, {token: context.root.$route.query.token}).then(response => {
        
        // @ts-ignore
        context.root.$store.commit("setBase64SchoolLogo", require("@/assets/images/logo_smarky_ol.png"));
        
        var user = response.data.user;

        // トークン設定
        var token = user.access_token
        document.cookie = `access_token=${token}`;
        document.cookie = 'smarky_user_id=' + user.id;
        document.cookie = "api_kind=sso_student_login";
        document.cookie = `smarky_is_parent=${response.data.is_parent ? "1" : "0"}`;
        context.root.$store.commit("setCurrentUser", user);
        context.root.$store.commit("setStudentCode", response.data.student_code);
        context.root.$store.commit("setStudentName", response.data.student_name);
        context.root.$store.commit("setIsParent", response.data.is_parent);
        context.root.$store.commit("setSchoolUrlPrefix", response.data.school_url_prefix);
        context.root.$store.commit("setIsSSO", true);

        if(context.root.$store.getters.isOptionLessonActive){
          context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/lesson_class_list`).catch(err => {});
        }else{
          context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/sheet_list`).catch(err => {});
        }
        context.root.$store.commit("setIsHeaderDisp", true);
      })
      .catch(error=>{
        // エラーの場合はアラートを表示してウィンドウを閉じる
        if(error.response.data && error.response.data.errors && error.response.status == 422){
          alert(`${error.response.data.errors[0]}ブラウザを終了します。`);
        }else{
          alert("認証に失敗しました。ブラウザを終了します。");
        }
        window.close();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    }
  }
})
